<span
  class="locked"
  *ngIf="locked && !hideTooltip"
  [rivTooltip]="'You don\'t have permission to view this item'"
>
  <ng-container *ngTemplateOutlet="content"></ng-container>
</span>
<span class="locked" *ngIf="locked && hideTooltip">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</span>
<ng-container *ngIf="!locked">
  <ng-container *ngTemplateOutlet="content"></ng-container>
</ng-container>
<ng-template #content><ng-content></ng-content></ng-template>
